import type { LayoutType } from '../types';

const INLINE_LAYOUTS = ['inline', 'section'] as const;
type InlineLayout = (typeof INLINE_LAYOUTS)[number];

export const isInlineLayout = (layout: LayoutType): layout is InlineLayout =>
  !!INLINE_LAYOUTS.find((inlineLayout) => inlineLayout === layout);
